// app\customs\errormessage\index.tsx

"use client";
import React from "react";
import "./index.css";

interface ErrorMessageProps {
  message?: string; // 「メイン||詳細」で渡す
  onClose?: () => void;
  type?: "error" | "warning" | "info";
}

/**
 * 共通エラーメッセージ表示コンポーネント
 * OK-NET 全画面で共通利用可能
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onClose,
  type = "error",
}) => {
  if (!message) return null;

  // メッセージを「||」で分割（例："保存に失敗しました||詳細内容"）
  const [mainMessage, detailMessage] = message.split("||");

  // クラス名をCSSに合わせて整理
  const className =
    type === "error"
      ? "error-message error"
      : type === "warning"
      ? "error-message warning"
      : "error-message info";

  const title =
    type === "error" ? "エラー" : type === "warning" ? "警告" : "お知らせ";

  return (
    <div className="error-overlay">
      <div className={className} role="alert">
        <div className="error-header">
          <h2>{title}</h2>
          <button onClick={onClose} className="close-button">
            <i className="far fa-times-circle"></i>
          </button>
        </div>

        <p className="error-body">{mainMessage}</p>

        {detailMessage && (
          <pre className="error-details">{detailMessage}</pre>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
